import { render, staticRenderFns } from "./TextReadOnly.vue?vue&type=template&id=0d5d5011&"
import script from "./TextReadOnly.vue?vue&type=script&lang=js&"
export * from "./TextReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5d5011')) {
      api.createRecord('0d5d5011', component.options)
    } else {
      api.reload('0d5d5011', component.options)
    }
    module.hot.accept("./TextReadOnly.vue?vue&type=template&id=0d5d5011&", function () {
      api.rerender('0d5d5011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/text/TextReadOnly.vue"
export default component.exports